"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>Price_Price
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_HotlListingCard_styles_js_namespaceObject = require("../../HotlListingCard.styles.js");
const PricelineLogo_js_namespaceObject = require("../../../../svgs/PricelineLogo.js");
var PricelineLogo_js_default = /*#__PURE__*/ __webpack_require__.n(PricelineLogo_js_namespaceObject);
const VipLogo_js_namespaceObject = require("../../../../svgs/VipLogo.js");
var VipLogo_js_default = /*#__PURE__*/ __webpack_require__.n(VipLogo_js_namespaceObject);
const getNightlyRate = ({ priceDisplayRegulation, nightlyAllRoomsPriceExcludingTax, nightlyRateIncludingTaxesAndFees, nightlyRateExcludingTaxesAndFees, price })=>{
    if ('TOTAL_PRICE_PROMINENT' === priceDisplayRegulation && nightlyRateIncludingTaxesAndFees) return nightlyRateIncludingTaxesAndFees;
    if ('TAX_EXCL_TOTAL_PRICE_PROMINENT' === priceDisplayRegulation && nightlyAllRoomsPriceExcludingTax) return nightlyAllRoomsPriceExcludingTax;
    return nightlyRateExcludingTaxesAndFees || price || '';
};
const getStrikePrice = ({ priceDisplayRegulation, grandTotalStrikeThroughPriceExcludingTax, grandTotalStrikeThroughPrice })=>{
    if ('TOTAL_PRICE_PROMINENT' === priceDisplayRegulation && grandTotalStrikeThroughPrice) return grandTotalStrikeThroughPrice;
    if ('TAX_EXCL_TOTAL_PRICE_PROMINENT' === priceDisplayRegulation && grandTotalStrikeThroughPriceExcludingTax) return grandTotalStrikeThroughPriceExcludingTax;
    return grandTotalStrikeThroughPriceExcludingTax || grandTotalStrikeThroughPrice || '';
};
const getTotalPrice = ({ priceDisplayRegulation, grandTotalExcludingTax, totalPrice })=>{
    if ('TOTAL_PRICE_PROMINENT' === priceDisplayRegulation && totalPrice) return totalPrice;
    if ('TAX_EXCL_TOTAL_PRICE_PROMINENT' === priceDisplayRegulation && grandTotalExcludingTax) return grandTotalExcludingTax;
    return totalPrice || grandTotalExcludingTax || '';
};
const getSavingsPct = ({ priceDisplayRegulation, grandTotalSavingsPctExcludingTax, savingsPct })=>{
    if ('TOTAL_PRICE_PROMINENT' === priceDisplayRegulation && savingsPct) return savingsPct;
    if ('TAX_EXCL_TOTAL_PRICE_PROMINENT' === priceDisplayRegulation && grandTotalSavingsPctExcludingTax) return grandTotalSavingsPctExcludingTax;
    return savingsPct || grandTotalSavingsPctExcludingTax || '';
};
const Price = ({ price, totalPrice, currency, savingsPct, priceDisplayRegulation, nightlyRateIncludingTaxesAndFees, nightlyRateExcludingTaxesAndFees, grandTotalExcludingTax, grandTotalSavingsPctExcludingTax, grandTotalStrikeThroughPrice, grandTotalStrikeThroughPriceExcludingTax, nightlyAllRoomsPriceExcludingTax })=>{
    let parsedStrikePrice = 0;
    let parsedNightlyRate = 0;
    let parsedTotalPrice = 0;
    const nightlyRate = getNightlyRate({
        priceDisplayRegulation,
        nightlyAllRoomsPriceExcludingTax,
        nightlyRateIncludingTaxesAndFees,
        nightlyRateExcludingTaxesAndFees,
        price
    });
    const resolvedStrikePrice = getStrikePrice({
        priceDisplayRegulation,
        grandTotalStrikeThroughPriceExcludingTax,
        grandTotalStrikeThroughPrice
    });
    const resolvedTotalPrice = getTotalPrice({
        priceDisplayRegulation,
        grandTotalExcludingTax,
        totalPrice
    });
    const resolvedSavingsPct = getSavingsPct({
        priceDisplayRegulation,
        grandTotalSavingsPctExcludingTax,
        savingsPct
    });
    if (!isNaN(Number(resolvedStrikePrice))) parsedStrikePrice = Math.round(parseInt(resolvedStrikePrice));
    if (!isNaN(Number(nightlyRate))) parsedNightlyRate = Math.round(parseInt(nightlyRate));
    if (!isNaN(Number(resolvedTotalPrice))) parsedTotalPrice = Math.round(parseInt(resolvedTotalPrice));
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
        justifyContent: 'space-between',
        alignItems: 'center',
        width: 1,
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                width: '65%',
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                    width: 1,
                    children: resolvedSavingsPct ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Box, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                                alignItems: "center",
                                "data-testid": "PENNY_PCLN_VIPICON",
                                children: [
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Relative, {
                                        pr: 2,
                                        top: '3px',
                                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(PricelineLogo_js_default(), {
                                            width: '60px',
                                            height: '20px'
                                        })
                                    }),
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(VipLogo_js_default(), {
                                            width: '24px',
                                            height: '24px'
                                        })
                                    }),
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Relative, {
                                        top: '-3px',
                                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                            color: 'pricePrimary.base',
                                            lineHeight: '22px',
                                            ml: 1,
                                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Text.span, {
                                                fontSize: 2,
                                                fontWeight: "bold",
                                                children: [
                                                    parseInt(resolvedSavingsPct, 10),
                                                    "% Off"
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Flex, {
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                    fontSize: 0,
                                    color: 'text.light',
                                    children: "Lower price because you're a VIP!"
                                })
                            })
                        ]
                    }) : null
                })
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Box, {
                textAlign: 'right',
                children: [
                    parsedStrikePrice > 0 ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Relative, {
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_HotlListingCard_styles_js_namespaceObject.TextStrikeThrough, {
                            lineHeight: '22px',
                            children: [
                                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_HotlListingCard_styles_js_namespaceObject.PriceCurrencyStrikeThrough, {
                                    fontSize: '8px',
                                    fontWeight: "bold",
                                    children: currency
                                }),
                                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text.span, {
                                    fontSize: 1,
                                    fontWeight: "bold",
                                    children: parsedStrikePrice
                                })
                            ]
                        })
                    }) : null,
                    parsedNightlyRate ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Text, {
                        color: 'pricePrimary.base',
                        lineHeight: '22px',
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_HotlListingCard_styles_js_namespaceObject.PriceCurrency, {
                                fontSize: 0,
                                fontWeight: "bold",
                                children: currency
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text.span, {
                                fontSize: 4,
                                fontWeight: "bold",
                                children: parsedNightlyRate
                            })
                        ]
                    }) : null,
                    parsedTotalPrice ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Text, {
                        fontSize: 0,
                        lineHeight: '16px',
                        color: 'text.light',
                        children: [
                            "Total: ",
                            currency,
                            parsedTotalPrice
                        ]
                    }) : null
                ]
            })
        ]
    });
};
const Price_Price = Price;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
